import { SegmentedControl } from 'cng-common/components/segmentedControl'

import { TStrategicInitiativesRtm } from '../../model'

interface IStrategicInitiativesRtmProps {
  rtm: TStrategicInitiativesRtm
  onChange: (rtm: TStrategicInitiativesRtm) => void
}

export const StrategicInitiativesRtm = ({ rtm, onChange }: IStrategicInitiativesRtmProps) => (
  <SegmentedControl
    useItemKeys
    selectedItem={rtm}
    onItemSelect={(key) => onChange(key as TStrategicInitiativesRtm)}
  >
    <SegmentedControl.Item itemKey="Reseller">
      <span>Reseller</span>
    </SegmentedControl.Item>
    <SegmentedControl.Item itemKey="Distributor">
      <span>Distributor</span>
    </SegmentedControl.Item>
  </SegmentedControl>
)

StrategicInitiativesRtm.displayName = 'StrategicInitiativesRtm'
